import * as React from 'react';
import { SVGProps } from 'react';

const GridLayoutIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    {...props}
  >
    <g strokeLinecap="round" strokeLinejoin="round" clipPath="url(#a)">
      <path d="M25.333 28h-4a2.666 2.666 0 0 1-2.667-2.667v-6.666A2.666 2.666 0 0 1 21.333 16h4a2.666 2.666 0 0 1 2.666 2.667v6.666A2.666 2.666 0 0 1 25.333 28ZM25.333 12h-4a2.666 2.666 0 0 1-2.667-2.667V6.667A2.666 2.666 0 0 1 21.333 4h4a2.666 2.666 0 0 1 2.666 2.667v2.666A2.666 2.666 0 0 1 25.333 12ZM6.667 4h4a2.666 2.666 0 0 1 2.666 2.667v6.666A2.666 2.666 0 0 1 10.667 16h-4A2.666 2.666 0 0 1 4 13.333V6.667A2.666 2.666 0 0 1 6.667 4ZM6.667 20h4a2.666 2.666 0 0 1 2.666 2.667v2.666A2.666 2.666 0 0 1 10.667 28h-4A2.666 2.666 0 0 1 4 25.333v-2.666A2.666 2.666 0 0 1 6.667 20Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default GridLayoutIcon;
